import React from "react";
import Image from "react-bootstrap/Image";

export const NominationTableViewBody = ({
  userImage,
  userName,
  userDate,
  userTime,
  status,
}) => {
  return (
    <tbody>
      <tr className="enUserFavoritesTableBody">
        <td style={{ width: "40%" }}>
          <div className="col-12 p-0 d-flex align-items-center">
            <div className="restaurant_image_box_user">
              <Image
                src={userImage}
                alt="Profile pic"
                title="Profile Pic"
                fluid
              />
            </div>
            <div className="f12-500">{userName}</div>
          </div>
        </td>
        <td style={{ width: "30%" }}>
          <div className="f14-500">{userDate}</div>
          <div className="f14-500">{userTime}</div>
        </td>
        <td style={{ width: "30%" }}>
          <div className="border-left-box">
            <div className="f16-400">{status}</div>
          </div>
        </td>
      </tr>
    </tbody>
  );
};
